import { useTranslations } from "@jugl-web/utils";
import React from "react";
import { useInstagramAccount } from "@web-src/modules/client-support/pages/ClientSupportPage/providers/InstagramAccountProvider/useInstagramAccount";
import { InstagramAccountCard } from "../../../../components/InstagramAccountCard";
import { ReactComponent as FollowersIcon } from "./assets/followers.svg";
import { ReactComponent as FollowingIcon } from "./assets/following.svg";
import { CRMConnectionTipsSection } from "../../../../components/CRMConnectionTipsSection/CRMConnectionTipsSection";
import { CRMInfoSection } from "../../../../components/CRMInfoSection";

export const InstagramGeneralInfoTab: React.FC = () => {
  const { t } = useTranslations();
  const { instagramAccount } = useInstagramAccount();

  if (!instagramAccount) return null;
  return (
    <>
      <InstagramAccountCard />
      {instagramAccount.status === "connected" ? (
        <CRMInfoSection
          title={t({
            id: "client-support-page.account-info",
            defaultMessage: "Account info:",
          })}
        >
          <div className="flex flex-col">
            <div className="flex items-center gap-3 px-6 py-2">
              <FollowersIcon />
              <span className="font-secondary leading-[140%] font-medium tracking-[0.16px] text-dark italic">
                {instagramAccount.followers_count}
              </span>
              <span className="font-secondary text-[13px] leading-[150%] tracking-[0.13px] text-dark-700">
                {t({
                  id: "client-support-page.followers",
                  defaultMessage: "Followers",
                })}
              </span>
            </div>
            <div className="my-2 h-px w-full bg-[#F2F2F2]" />
            <div className="flex items-center gap-3 px-6 py-2">
              <FollowingIcon />
              <span className="font-secondary leading-[140%] font-medium tracking-[0.16px] text-dark italic">
                {instagramAccount.follows_count}
              </span>
              <span className="font-secondary text-[13px] leading-[150%] tracking-[0.13px] text-dark-700">
                {t({
                  id: "client-support-page.following",
                  defaultMessage: "Following",
                })}
              </span>
            </div>
          </div>
        </CRMInfoSection>
      ) : (
        <CRMConnectionTipsSection />
      )}
    </>
  );
};
